import React from 'react';
import { ExpressTruckIcon } from '../../helpers/icon-utils';
import {
  showTodayOrTomorrow,
  formatDate,
  getPriorityDeliveryOption
} from '../../../components/helper/utils';
import {
  showEmptyShippingMessage
} from '../../helpers/pod-fulfillment-utils';
import { PodMessage } from '../PodMessage';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Badge, Typography } from '@one-thd/sui-atomic-components';
import { BOLT_BROWN_ICON_URL } from '../../../components/constants';

export const PriorityDeliveryOptions = ({
  product,
  showFasterPodSpacing = false,
  isNarrowPod = false,
  enablePodOnDemandDelivery = false,
  isMobile = false
}) => {
  const priorityDeliveryOption = product?.fulfillment?.fulfillmentOptions
    ?.find((fo) => fo?.type === 'delivery')?.priorityDeliveryOptions|| [];

  const filterFasterDeliveryOption = getPriorityDeliveryOption(priorityDeliveryOption, enablePodOnDemandDelivery);

  if (!filterFasterDeliveryOption) {
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    return showFasterPodSpacing ? <div className="sm:sui-min-h-[27.5px]" /> : null;
  }

  const endDate = filterFasterDeliveryOption?.date;
  const timeline = filterFasterDeliveryOption?.timeline;
  if (filterFasterDeliveryOption?.timeline?.toLowerCase()?.includes('hour')) {
    const normalizedOnDemandTimeline = timeline?.replace(/s$/i, '')?.replace(/\s+/g, '-');
    const width = isMobile ? 8 : 10;
    const height = isMobile ? 12 : 14
    return (
      <div className="sui-mt-[6px]">
        <Badge
          color="warning"
          variant="strong"
          size={isMobile ? 'small': 'base'}
          data-testid="priority-delivery-badge"
        >
          <div className="sui-flex sui-py-2">
            <img
              src={BOLT_BROWN_ICON_URL}
              alt="bolt"
              width={width}
              height={height}
              data-testid="bolt-icon"
              className="sui-mr-1"
            />
            <div className="sui-mr-1 sui-text-xs" style={{ color: '#582301' }}>{normalizedOnDemandTimeline} Delivery</div>
          </div>
        </Badge>
      </div>
    );
  }
  
  const formattedEndDate = endDate && formatDate(endDate, false);
  const dateText = showTodayOrTomorrow(endDate, true, timeline, formattedEndDate, false);
  return (
    <PodMessage
      messageIcon={ExpressTruckIcon}
      messageType="Faster Delivery"
      isNarrowPod={isNarrowPod}
    >
      Get it {dateText}
    </PodMessage>
  );
};